import React, { useEffect, useState } from "react";
import BuilderTabs from "../../Layouts/BuilderTabs";
import { NewPrefilter } from "../../components/BuilderComponents/PreFilters/PreFilter";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Textarea from "../../components/FormComponents/Textarea";
import { useFormContext } from "../../context/FormContext";
import { useModalContext } from "../../context/ModalContext";
import { convertFields, formFieldConfig } from "../../utils/Config/DefaultConfig/formFieldConfig";
import FieldCustomFunction from "./EditFieldAttribute/EditCustom";

// Basic Fields
import EditCheckbox from "./EditFormElements/Basic/EditCheckbox";
import EditDate from "./EditFormElements/Basic/EditDate";
import EditEmail from "./EditFormElements/Basic/EditEmail";
import EditFile from "./EditFormElements/Basic/EditFile";
import EditImage from "./EditFormElements/Basic/EditImage";
import EditJson from "./EditFormElements/Basic/EditJson";
import EditLabel from "./EditFormElements/Basic/EditLabel";
import EditMultiDate from "./EditFormElements/Basic/EditMultiDate";
import EditNumber from "./EditFormElements/Basic/EditNumber";
import EditPassword from "./EditFormElements/Basic/EditPassword";
import EditPercentage from "./EditFormElements/Basic/EditPercentage";
import EditPhone from "./EditFormElements/Basic/EditPhone";
import EditRadio from "./EditFormElements/Basic/EditRadio";
import EditRichtext from "./EditFormElements/Basic/EditRichtext";
import EditSelect from "./EditFormElements/Basic/EditSelect";
import EditSelectboxes from "./EditFormElements/Basic/EditSelectboxes";
import EditSpacer from "./EditFormElements/Basic/EditSpacer";
import EditTextarea from "./EditFormElements/Basic/EditTextarea";
import EditTextfield from "./EditFormElements/Basic/EditTextfield";
import EditTime from "./EditFormElements/Basic/EditTime";
import EditToggle from "./EditFormElements/Basic/EditToggle";
import EditUrl from "./EditFormElements/Basic/EditUrl";
import EditMultiSelectDropdown from "./EditFormElements/Basic/EditMultiSelectDropdown";

// Advanced Fields - Reference Fields
import EditAppuser from "./EditFormElements/Advance/RefrenceFields/EditAppuser";
// import EditCommunityUser from "./EditFormElements/Advance/RefrenceFields/EditCommunityUser";
import EditGlobalData from "./EditFormElements/Advance/RefrenceFields/EditGlobalData";
import EditLookup from "./EditFormElements/Advance/RefrenceFields/EditLookup";
import EditLookupSm from "./EditFormElements/Advance/RefrenceFields/EditLookupSm";

// Advanced Fields - Grouping Fields
import EditButtonGroup from "./EditFormElements/Advance/GroupingFields/EditButtonGroup";
import EditContainer from "./EditFormElements/Advance/GroupingFields/EditContainer";
import EditRecordset from "./EditFormElements/Advance/GroupingFields/EditRecordset";
import EditRecordsetList from "./EditFormElements/Advance/GroupingFields/EditRecordsetList";
import EditRichGrid from "./EditFormElements/Advance/GroupingFields/EditRichGrid";

// Advanced Fields - More Fields
import EditAudio from "./EditFormElements/Advance/MoreFields/EditAudio";
import EditButton from "./EditFormElements/Advance/MoreFields/EditButton";
import EditContent from "./EditFormElements/Advance/MoreFields/EditContent";
import EditCounter from "./EditFormElements/Advance/MoreFields/EditCounter";
import EditCurrency from "./EditFormElements/Advance/MoreFields/EditCurrency";
import EditDatetime from "./EditFormElements/Advance/MoreFields/EditDatetime";
import EditDisabled from "./EditFormElements/Advance/MoreFields/EditDisabled";
import EditGeolocation from "./EditFormElements/Advance/MoreFields/EditGeolocation";
import EditIdGen from "./EditFormElements/Advance/MoreFields/EditIdGen";
import EditLearningTags from "./EditFormElements/Advance/MoreFields/EditLearningTags";
import EditLearningText from "./EditFormElements/Advance/MoreFields/EditLearningText";
import EditRatings from "./EditFormElements/Advance/MoreFields/EditRatings";
import EditSelectChips from "./EditFormElements/Advance/MoreFields/EditSelectChips";
import EditSignature from "./EditFormElements/Advance/MoreFields/EditSignature";
import EditSlider from "./EditFormElements/Advance/MoreFields/EditSlider";
import EditVideo from "./EditFormElements/Advance/MoreFields/EditVideo";

import { hasOwn } from "../../commonFunctions/arrayFunc";
import BasicStyleEditor from "../../components/BuilderComponents/BasicStyleEditor";
import CopyToClipboard from "../../components/BuilderComponents/CopyToClipboard";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";
import { useNavigationContext } from "../../context/NavigationContext";
import { useTableContext } from "../../context/TableContext";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { generateObjectId } from "../../utils/objectIdUtils";
import { toastSuccess } from "../../utils/toastUtils";
import DefaultAction from "./EditFieldAttribute/Actions/DefaultAction";
import OnChangeAction from "./EditFieldAttribute/Actions/OnChangeAction";
import FieldVisibility from "./EditFieldAttribute/FieldVisibility";
import EditLookupRdbms from "./EditFormElements/Advance/RefrenceFields/EditLookupRdbms";
import EditMasterDataLookup from "./EditFormElements/Advance/RefrenceFields/EditMasterDataLookup";
import EditOcr from "./EditFormElements/Basic/EditOcr";
import EditDateRange from "./EditFormElements/Basic/EditDateRange";
import RegexInput from "../../components/BuilderComponents/Regex/RegexInput";
import EditDocumentOcr from "./EditFormElements/Basic/EditDocumentOcr";
import ClassSelectorLayout from "../../components/ClassSelectorLayout/ClassSelectorLayout";
import HttpTemplatePrefilter from "../../components/BuilderComponents/PreFilters/HttpTemplatePrefilter";
import useZTheme from "../../hooks/useZTheme";
import HttpRequest from "../../components/BuilderComponents/NewJobConfiguration/HttpRequest/HttpRequest";

const prefilterFields = ["lookup", "lookup-sm", "linked-sm-lookup", "app-user", "masterdata-lookup", "global-data"];
const fieldfilterFields = ["lookup", "lookup-sm", "global-data", "masterdata-lookup"];

const RightSideFieldEditSection = ({ editFieldId, setEditFieldId, tableID, editFieldData, setEditFieldData }) => {
  // const [editFieldData, setEditFieldData] = useState(null);
  useZTheme("desktop");
  const {
    renderFieldsData,
    renderFieldsArray,
    setRenderFieldsArray,
    saveCurrentSectionInData,
    formActvityData,
    formSectionsData
  } = useFormContext();
  const [allKeysOfFields, setAllKeysOfFields] = useState([]);
  const scripts = [
    ...(formActvityData?.onchange_custom_js?.scripts || []),
    ...(formSectionsData.current?.[0]?.onchange_custom_js?.scripts || [])
  ];
  console.log("tableID RightSideFieldEditSection", tableID);

  const saveEditField = () => {
    let newRenderFieldData = JSON.parse(JSON.stringify(renderFieldsData.current));
    if (editFieldId.parent) {
      const parentField = newRenderFieldData[editFieldId.parent];
      const editIndex = parentField.components.findIndex((field) => field.id === editFieldId.id);
      newRenderFieldData[editFieldId.parent].components[editIndex] = editFieldData;
      renderFieldsData.current = newRenderFieldData;
    } else {
      newRenderFieldData[editFieldData.id] = editFieldData;
      renderFieldsData.current = newRenderFieldData;
    }

    setRenderFieldsArray([...renderFieldsArray]);
    // setEditFieldId({
    //   parent: null,
    //   id: null
    // });
  };

  const handleHttpRequestDataChange = (updater, index) => {
    setEditFieldData((prev) => {
      const currentArray = prev.http_job_trigger || [];
      const currentItem = currentArray[index] || {};
      const newItem = updater(currentItem);
      const newArray = [...currentArray];
      newArray[index] = newItem;
      return { ...prev, http_job_trigger: newArray };
    });
  };

  const getAllKeysOfCurrentFields = () => {
    const newArray = saveCurrentSectionInData();
    const keysArray = {};
    newArray.forEach((field) => {
      keysArray[field.id] = field;
      if (field.type === "container" || field.type === "recordset-list" || field.type === "recordset") {
        field.components.forEach((containerField) => {
          keysArray[containerField.id] = containerField;
        });
      }
    });
    setAllKeysOfFields(keysArray);
  };
  const getTabsData = () => {
    const basicTabs = [
      {
        label: "Fields",
        content: (
          <EditFormFieldTab
            editFieldData={editFieldData}
            tableID={tableID}
            fields={Object.values(allKeysOfFields)}
            setEditFieldData={setEditFieldData}
          />
        )
      }
    ];
    if (prefilterFields.includes(editFieldData.type)) {
      //lookup, lookup-sm, linked-sm-lookup, app-user
      basicTabs.push({
        label: "PreFilter",
        content: (
          <PreFilterForFormField
            editFieldData={editFieldData}
            setEditFieldData={setEditFieldData}
            tableId={tableID}
            fields={Object.values(allKeysOfFields)}
          />
        )
      });
    }
    if (fieldfilterFields.includes(editFieldData.type)) {
      // lookup, lookup-sm, global-data
      basicTabs.push({
        label: "Field Filters",
        content: (
          <FieldFilterForFormField
            editFieldData={editFieldData}
            setEditFieldData={setEditFieldData}
            fields={Object.values(allKeysOfFields)}
            tableId={tableID}
          />
        )
      });
    }
    if (editFieldData.defaultAction) {
      basicTabs.push({
        label: "Basic Actions",
        content: (
          <DefaultAction
            editFieldData={editFieldData}
            setEditFieldData={setEditFieldData}
            allKeysOfFields={allKeysOfFields}
          />
        )
      });
    }
    if (editFieldData.on_change) {
      basicTabs.push({
        label: `${editFieldData.type === "button" ? "OnClick Actions" : "OnChange Actions"}`,
        content: (
          <OnChangeAction
            editFieldData={editFieldData}
            setEditFieldData={setEditFieldData}
            allKeysOfFields={allKeysOfFields}
          />
        )
      });
    }
    if (editFieldData.type === "button") {
      basicTabs.push({
        label: "HTTP Request",
        content: (
          <HttpRequest
            httpRequestData={editFieldData?.http_job_trigger?.[0] || {}}
            onHttpDataChange={(updater) => handleHttpRequestDataChange(updater, 0)}
            tableId={tableID}
            formFields={Object.values(allKeysOfFields)}
          />
        )
      });
    }
    basicTabs.push({
      label: "Advanced",
      content: (
        <AdvanceEditForFormField
          editFieldData={editFieldData}
          setEditFieldData={setEditFieldData}
          tableID={tableID}
          editFieldId={editFieldId}
          setEditFieldId={setEditFieldId}
          renderFieldsData={renderFieldsData}
          custom_js_options={scripts}
        />
      )
    });

    if (editFieldData?.style) {
      basicTabs.push({
        label: "Style",
        content: <FormFieldStyleEdit editFieldData={editFieldData} setEditFieldData={setEditFieldData} />
      });
    }

    if (editFieldData?.type === "button") {
      basicTabs.push({
        label: "Style",
        content: (
          <ClassSelectorLayout
            id={editFieldData.id}
            type={"button"}
            defaultSelected={editFieldData.classes || []}
            onChange={(newClasses) =>
              setEditFieldData({
                ...editFieldData,
                classes: newClasses
              })
            }
          />
        )
      });
    }

    return basicTabs;
  };

  useEffect(() => {
    if (editFieldId.parent) {
      const parentField = renderFieldsData.current[editFieldId.parent];
      const editIndex = parentField.components.findIndex((field) => field.id === editFieldId.id);
      setEditFieldData(parentField.components[editIndex]);
    } else {
      setEditFieldData(renderFieldsData.current[editFieldId.id]);
    }
    getAllKeysOfCurrentFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editFieldId]);

  useEffect(() => {
    if (editFieldData) {
      saveEditField();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editFieldData]);

  if (!editFieldData || !editFieldData.type) return null;
  return (
    <div>
      <BuilderTabs contentClass="edit_popup_formField" tabs={getTabsData()} />
    </div>
  );
};

const EditFormFieldTab = (props) => {
  const { editFieldData } = props;

  return (
    <div className="flex_column gap_4">
      <div className="d_flex align_center gap_1">
        <span>{editFieldData["id"]}</span>
        <CopyToClipboard
          text={editFieldData["id"]}
          successMessage="Field ID copied to clipboard"
          errorMessage="Failed to copy Field ID"
        />
      </div>
      <GetEditAttributes {...props} />
    </div>
  );
};

const MoveToGlobal = ({ editFieldData, tableID }) => {
  const [smData, setSmData] = useState({});

  const cloneToGlobalData = async () => {
    const clonedField = { ...editFieldData, id: generateObjectId() };
    const copySmData = JSON.parse(JSON.stringify(smData));
    if (!copySmData.global_data_form.fields) {
      copySmData.global_data_form.fields = [];
    }
    copySmData.global_data_form.fields = [...copySmData.global_data_form.fields, clonedField];
    setSmData(copySmData);
    // const config = {
    //   global_data_form: {
    //     fields: [...copySmData.global_data_form.fields, clonedField]
    //   }
    // }
    try {
      await axiosInstance.put(`/state-machine/${tableID}/canvas`, { ...copySmData });
      // const { message } = await axiosInstance.patch(`/state-machine/${tableID}`, { ...config });
      toastSuccess("Field cloned to global data");
    } catch (error) {
      handleApiError(error);
    }
  };
  const fetchStateMachine = async () => {
    try {
      const { data } = await axiosInstance.get(`/state-machine/${tableID}`);

      setSmData(data.config);
    } catch (error) {
      handleApiError(error);
    }
  };
  useEffect(() => {
    fetchStateMachine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="d_flex justify_end">
      <Button variant="secondary" onClick={() => cloneToGlobalData()}>
        Clone to global data
      </Button>
    </div>
  );
};

const ConvertFormField = ({ editFieldId, setEditFieldId, renderFieldsData, editFieldData }) => {
  const { getUserConfirmation } = useModalContext();

  const handleTypeChange = async (value) => {
    const userConfirmed = await getUserConfirmation("You want to change <strong>Field Type</strong>");
    if (!userConfirmed) return;
    let newRenderFieldData = JSON.parse(JSON.stringify(renderFieldsData.current));
    const newFieldConfig = formFieldConfig[value];
    const modifiedFieldConfig = { ...newFieldConfig, id: editFieldData.id, label: editFieldData.label };
    if (editFieldId.parent) {
      const parentField = newRenderFieldData[editFieldId.parent];
      const editIndex = parentField.components.findIndex((field) => field.id === editFieldId.id);
      newRenderFieldData[editFieldId.parent].components[editIndex] = modifiedFieldConfig;
      renderFieldsData.current = newRenderFieldData;
    } else {
      newRenderFieldData[editFieldData.id] = modifiedFieldConfig;
      renderFieldsData.current = newRenderFieldData;
    }
    setEditFieldId({
      parent: null,
      id: null
    });
  };
  const convertFieldsOptions =
    (editFieldData.type && convertFields[editFieldData.type].map((field) => ({ id: field, name: field }))) || [];

  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData=""
        options={convertFieldsOptions}
        onChange={(obj) => handleTypeChange(obj.id)}
        placeholder="Select field"
        label="Convert Field Type"
      />
    </div>
  );
};

const PreFilterForFormField = ({ editFieldData, setEditFieldData, tableId, fields }) => {
  const { getAllRdbmsData } = useTableContext();
  const [loading, setLoading] = useState(true);
  const [actualTableId, setActualTableId] = useState("");
  const [actualTableType, setActualTableType] = useState("statemachine");
  const [actualFolderIds, setActualFolderIds] = useState([]);
  const tableFields = fields?.map((field) => convertFormFieldToTableField(field)) || [];

  const handleChangePrefilter = (obj) => {
    setEditFieldData({
      ...editFieldData,
      pre_filters: obj.prefilter,
      prefilters_joined_by: obj.prefilters_joined_by
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let tableIdVal = editFieldData.table_id || "";
        let tableTypeVal = "statemachine";
        let folderIdsVal = [];

        if (editFieldData.type === "app-user") {
          tableIdVal = tableId;
          folderIdsVal = ["logged_in_user"];
        }

        if (editFieldData.type === "masterdata-lookup" && editFieldData.masterdata_type === "rdbms") {
          tableIdVal = editFieldData.masterdata_id || "";
          tableTypeVal = "rdbms";
        }

        if (editFieldData.type === "global-data") {
          const { data: smData } = await axiosInstance.get(`/state-machine/${tableId}`);
          const globalField = smData?.config?.global_data_form?.fields?.find(
            (field) => field.id === editFieldData.global_field.id
          );

          if (globalField?.type === "masterdata-lookup" && globalField.masterdata_type === "rdbms") {
            tableIdVal = globalField.masterdata_id || "";
            tableTypeVal = "rdbms";
          }
          if (
            globalField?.type === "lookup-sm" ||
            globalField?.type === "linked-sm-lookup" ||
            globalField?.type === "lookup"
          ) {
            tableIdVal = globalField.table_id || "";
          }
        }
        if (tableTypeVal === "rdbms" && tableIdVal) {
          await getAllRdbmsData();
        }
        setActualFolderIds(folderIdsVal);
        setActualTableId(tableIdVal);
        setActualTableType(tableTypeVal);
      } catch (error) {
        console.error("Error fetching RDBMS data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isHttpTemplateSource =
    editFieldData.type === "masterdata-lookup" &&
    editFieldData.data_source?.type === "http-template" &&
    editFieldData.data_source?.http_template_id;

  if (isHttpTemplateSource) {
    return (
      <div>
        <HttpTemplatePrefilter
          prefiltersWithFormula={{
            prefilter: editFieldData.pre_filters || [],
            prefilters_joined_by: editFieldData.prefilters_joined_by || ""
          }}
          templateId={editFieldData.data_source.http_template_id}
          onChange={handleChangePrefilter}
          valueOptions={tableFields}
        />
      </div>
    );
  }

  if (!actualTableId) {
    return <div>Please select table</div>;
  }

  if (loading) {
    return <div>Loading pre-filter data...</div>;
  }

  return (
    <div>
      <NewPrefilter
        prefiltersWithFormula={{
          prefilter: editFieldData.pre_filters || [],
          prefilters_joined_by: editFieldData.prefilters_joined_by || ""
        }}
        tableId={actualTableId}
        tableType={actualTableType}
        handleChange={handleChangePrefilter}
        folderIds={actualFolderIds}
      />
    </div>
  );
};

const FieldFilterForFormField = ({ editFieldData, setEditFieldData, fields, tableId }) => {
  const { getAllRdbmsData } = useTableContext();
  const [loading, setLoading] = useState(true);
  const [filterTableId, setFilterTableId] = useState(editFieldData.table_id || "");
  const [fieldTableType, setFieldTableType] = useState("entity");
  const tableFields = fields.map((field) => convertFormFieldToTableField(field));

  const handleChangePrefilter = (data) => {
    setEditFieldData({
      ...editFieldData,
      field_filters: data.prefilter,
      field_filters_joined_by: data.prefilters_joined_by
    });
  };

  useEffect(() => {
    const determineInitialTableInfo = () => {
      let initialTableId = editFieldData.table_id || "";
      let initialTableType = "entity";

      const fieldType = editFieldData.global_field?.field_type;
      if (fieldType === "lookup" || fieldType === "lookup-sm") {
        initialTableId = editFieldData.global_field.table_id;
      }
      if (editFieldData.type === "masterdata-lookup") {
        if (editFieldData.masterdata_type === "rdbms") {
          initialTableId = editFieldData.masterdata_id || "";
          initialTableType = "rdbms";
        } else if (editFieldData.data_source?.type === "http-template") {
          initialTableId = editFieldData.data_source.http_template_id;
          initialTableType = "http-template";
        }
      }

      setFilterTableId(initialTableId);
      setFieldTableType(initialTableType);
    };

    determineInitialTableInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        if (fieldTableType === "rdbms" && filterTableId) {
          await getAllRdbmsData();
        }

        if (editFieldData.type === "global-data" && editFieldData.global_field?.field_type === "masterdata-lookup") {
          const { data: smData } = await axiosInstance.get(`/state-machine/${tableId}`);
          const globalField = smData?.config?.global_data_form?.fields?.find(
            (field) => field.id === editFieldData.global_field.id
          );

          if (globalField?.type === "masterdata-lookup" && globalField.masterdata_type === "rdbms") {
            setFilterTableId(globalField.masterdata_id || "");
            setFieldTableType("rdbms");
          }
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching RDBMS data", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterTableId, fieldTableType]);

  const isHttpTemplateSource = fieldTableType === "http-template" && filterTableId;

  if (isHttpTemplateSource) {
    return (
      <div>
        <HttpTemplatePrefilter
          prefiltersWithFormula={{
            prefilter: editFieldData.field_filters || [],
            prefilters_joined_by: editFieldData.field_filters_joined_by || ""
          }}
          templateId={filterTableId}
          onChange={handleChangePrefilter}
          valueOptions={tableFields}
        />
      </div>
    );
  }

  if (!filterTableId) {
    return <div>Please select field</div>;
  }

  if (loading) {
    return <div>Loading pre-filter data...</div>;
  }
  return (
    <div>
      <NewPrefilter
        prefiltersWithFormula={{
          prefilter: editFieldData.field_filters || [],
          prefilters_joined_by: editFieldData.field_filters_joined_by || ""
        }}
        tableId={filterTableId}
        tableType={fieldTableType}
        handleChange={handleChangePrefilter}
        filterValues={tableFields}
      />
    </div>
  );
};

const convertFormFieldToTableField = (field) => {
  const { id, type, label } = field;
  let table_id = "";
  if (field.type === "lookup" || field.type === "lookup-sm") {
    table_id = field.table_id || "";
  }
  if (field.type === "global-data" && field.global_field) {
    if (field.global_field.field_type === "lookup" || field.global_field.field_type === "lookup-sm") {
      table_id = field.global_field.table_id || "";
    }
  }

  return {
    id: id,
    form_key: id,
    data_key: id,
    data_type: getDataTypeFromFieldType(type),
    field_type: type,
    display: label,
    type: "field",
    activity_label: "",
    activity_id: "",
    activity_type: "",
    sub_fields: "",
    show: true,
    table_id: table_id
  };
};

function getDataTypeFromFieldType(fieldType) {
  switch (fieldType) {
    case "textfield":
    case "email":
    case "password":
    case "search":
    case "tel":
    case "url":
    case "color":
    case "learning-text":
    case "learning-tags":
    case "id-gen":
      return "text";
    case "number":
    case "range":
    case "ratings":
      return "number";
    case "date":
    case "datetime-local":
    case "month":
    case "time":
    case "week":
    case "datetime":
      return "date";
    case "textarea":
      return "textarea";
    case "checkbox":
    case "toggle":
      return "boolean";
    case "file":
      return "file";
    case "image":
      return "image";
    case "select-one":
    case "select-multiple":
    case "select":
      return "select";
    case "geolocation":
      return "geolocation";
    case "selectboxes":
      return "selectboxes";
    case "multi-select-dropdown":
      return "multi-select-dropdown";
    case "lookup":
    case "lookup-sm":
    case "linked-sm-lookup":
    case "recordset":
    case "app-user":
    case "object":
    case "phone":
    case "grid":
    case "rich-grid":
    case "global-data":
      return "object";
    case "recordset-list":
    case "object[]":
      return "object[]";
    case "lookup-id":
      return "lookup-id";
    case "currency":
      return "currency";
    default:
      return "unknown";
  }
}

const GetEditAttributes = (props) => {
  return (
    <div className="flex_column gap_4 form_basic_field_wrapper">
      <GetComponentByType {...props} />
    </div>
  );
};

const FormFieldStyleEdit = ({ editFieldData, setEditFieldData }) => {
  const updateClassAndInlineStyle = (data) => {
    setEditFieldData({
      ...editFieldData,
      style: {
        ...editFieldData?.style,
        className: data.classData,
        inline_style: data.inlineData
      }
    });
  };

  return (
    <BasicStyleEditor
      value={{
        classData: editFieldData?.style?.className || {},
        inlineData: editFieldData?.style?.inline_style || {}
      }}
      callbackFunction={updateClassAndInlineStyle}
      fieldType={editFieldData?.type || ""}
    />
  );
};

const AdvanceEditForFormField = ({
  editFieldData,
  setEditFieldData,
  tableID,
  editFieldId,
  setEditFieldId,
  renderFieldsData,
  custom_js_options
}) => {
  const { getCurrentPageData } = useNavigationContext();

  const pageName = getCurrentPageData().page;
  const handleInputBox = (e) => {
    const { name, value } = e.target;
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidate = (name, value) => {
    setEditFieldData({
      ...editFieldData,
      validate: {
        ...editFieldData.validate,
        [name]: value
      }
    });
  };
  const handleChangeWidth = (e) => {
    const value = e.target.value;
    if (value === "") {
      setEditFieldData({ ...editFieldData, mass_performance_width: 0 });
      return;
    }
    setEditFieldData({ ...editFieldData, mass_performance_width: parseInt(value) });
  };

  return (
    <div className="flex_column gap_4 form_basic_field_wrapper">
      {pageName === "form" && (
        <MoveToGlobal editFieldData={editFieldData} setEditFieldData={setEditFieldData} tableID={tableID} />
      )}
      {convertFields[editFieldData.type]?.length > 0 && (
        <ConvertFormField
          editFieldId={editFieldId}
          setEditFieldId={setEditFieldId}
          renderFieldsData={renderFieldsData}
          editFieldData={editFieldData}
        />
      )}
      <Input
        type="number"
        label="Width When Mass Performance"
        value={editFieldData.mass_performance_width}
        onChange={handleChangeWidth}
      />
      {hasOwn(editFieldData, "visibility_settings") && (
        <ExtraSubFormFields editFieldData={editFieldData} setEditFieldData={setEditFieldData} tableID={tableID} />
      )}
      {hasOwn(editFieldData, "ai_prompt") && (
        <Textarea
          key="ai_prompt"
          label="AI Validation"
          type="text"
          name={"ai_prompt"}
          value={editFieldData["ai_prompt"]}
          onChange={handleInputBox}
        />
      )}
      <RegexInput
        value={editFieldData.validate?.regex || ""}
        onChange={(value) => handleChangeValidate("regex", value)}
        regex_custom_error={editFieldData.validate?.regex_custom_error || ""}
        onCustomErrorChange={(value) => handleChangeValidate("regex_custom_error", value)}
      />
      <SingleSelectBox
        options={custom_js_options}
        valueKey="id"
        labelKey={["name"]}
        selectedData={editFieldData.validate?.custom_js_id || ""}
        onChange={(selected) => handleChangeValidate("custom_js_id", selected?.id || "")}
        label="OnChange Custom Function"
        placeholder="Select a script"
        isSearch
      />
      {hasOwn(editFieldData, "validate") && hasOwn(editFieldData.validate, "custom_js") && (
        <FieldCustomFunction
          editFieldValidation={editFieldData.validate}
          fieldData={editFieldData}
          setEditFieldValidation={(newValidate) => setEditFieldData({ ...editFieldData, validate: newValidate })}
          tableID={tableID}
          table_type={tableID === "appuser" ? "appuser" : "statemachine"}
        />
      )}
    </div>
  );
};

const ExtraSubFormFields = (props) => {
  const { editFieldData, setEditFieldData, tableID } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  return (
    <>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label="Read Only"
          checked={editFieldData.read_only}
          name="read_only"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label="Unique"
          checked={editFieldData.unique}
          name="unique"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label="Copy previous value"
          checked={editFieldData.copy_previous_value}
          name="copy_previous_value"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        {editFieldData.type === "number" && (
          <Input
            type="checkbox"
            label="Show sum"
            checked={editFieldData.show_sum}
            name="show_sum"
            onChange={({ target }) => handleChangeInput(target.name, target.checked)}
            containerClassName="w_50"
          />
        )}
      </div>
      <div className="field_horizontal_container">
        <div className="w_50">
          <Input
            label="Width"
            value={editFieldData.width}
            name="width"
            type="number"
            onChange={({ target }) => handleChangeInput(target.name, target.value)}
          />
        </div>
        <div className="w_50"></div>
      </div>

      <FieldVisibility editFieldData={editFieldData} setEditFieldData={setEditFieldData} tableID={tableID} />
    </>
  );
};

export default RightSideFieldEditSection;
export { GetEditAttributes };

const GetComponentByType = (props) => {
  const { editFieldData } = props;
  switch (editFieldData.type) {
    case "textfield":
      return <EditTextfield {...props} />;
    case "textarea":
      return <EditTextarea {...props} />;
    case "richtext":
      return <EditRichtext {...props} />;
    case "number":
      return <EditNumber {...props} />;
    case "phone":
      return <EditPhone {...props} />;
    case "password":
      return <EditPassword {...props} />;
    case "email":
      return <EditEmail {...props} />;
    case "checkbox":
      return <EditCheckbox {...props} />;
    case "toggle":
      return <EditToggle {...props} />;
    case "file":
      return <EditFile {...props} />;
    case "url":
      return <EditUrl {...props} />;
    case "image":
      return <EditImage {...props} />;
    case "lookup":
      return <EditLookup {...props} />;
    case "lookup-sm":
    case "linked-sm-lookup":
      return <EditLookupSm {...props} />;
    case "masterdata-lookup":
      return <EditMasterDataLookup {...props} />;
    case "lookup-rdbms":
      return <EditLookupRdbms {...props} />;
    case "global-data":
      return <EditGlobalData {...props} />;
    case "app-user":
      return <EditAppuser {...props} />;
    // case "community-user":
    //   return <EditCommunityUser {...props} />;
    case "container":
      return <EditContainer {...props} />;
    case "grid":
    case "rich-grid":
      return <EditRichGrid {...props} />;
    case "recordset":
      return <EditRecordset {...props} />;
    case "recordset-list":
      return <EditRecordsetList {...props} />;
    case "button-group":
      return <EditButtonGroup {...props} />;
    case "radio":
      return <EditRadio {...props} />;
    case "button":
      return <EditButton {...props} />;
    case "id-gen":
      return <EditIdGen {...props} />;
    case "learning-text":
      return <EditLearningText {...props} />;
    case "learning-tags":
      return <EditLearningTags {...props} />;
    case "select":
    case "number-select":
      return <EditSelect {...props} />;
    case "selectboxes":
      return <EditSelectboxes {...props} />;
    case "multi-select-dropdown":
      return <EditMultiSelectDropdown {...props} />;
    case "currency":
      return <EditCurrency {...props} />;
    case "date":
      return <EditDate {...props} />;
    case "date-range":
      return <EditDateRange {...props} />;
    case "multi-date":
      return <EditMultiDate {...props} />;
    case "time":
      return <EditTime {...props} />;
    case "datetime":
      return <EditDatetime {...props} />;
    case "disabled":
      return <EditDisabled {...props} />;
    case "content":
      return <EditContent {...props} />;
    case "geolocation":
      return <EditGeolocation {...props} />;
    case "ratings":
      return <EditRatings {...props} />;
    case "slider":
      return <EditSlider {...props} />;
    case "label":
      return <EditLabel {...props} />;
    case "percentage":
      return <EditPercentage {...props} />;
    case "select-chips":
      return <EditSelectChips {...props} />;
    case "video":
      return <EditVideo {...props} />;
    case "audio":
      return <EditAudio {...props} />;
    case "signature":
      return <EditSignature {...props} />;
    case "counter":
      return <EditCounter {...props} />;
    case "spacer":
      return <EditSpacer {...props} />;
    case "json":
      return <EditJson {...props} />;
    case "ocr":
    case "ai-doc-analyzer":
      return <EditOcr {...props} />;
    case "document-ocr":
      return <EditDocumentOcr {...props} />;
    default:
      return null;
  }
};
